import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 6.38559V18.7824C14.308 17.7854 16.1284 17.2477 17.9998 17.25C18.7587 17.2492 19.5138 17.3371 20.25 17.5112V4.81008C19.5358 4.60805 18.7812 4.50001 18 4.50001L17.9989 4.50001C16.0796 4.49728 14.2235 5.16646 12.75 6.38559ZM11.25 18.7831V6.38561C9.77643 5.16654 7.92037 4.49736 6.00104 4.50001L6 4.50001C5.21882 4.50001 4.46415 4.60805 3.75 4.81008V17.5112C4.4864 17.3371 5.24176 17.2492 6.00083 17.25C7.93291 17.2502 9.73485 17.8132 11.25 18.7831ZM12 5.06396C13.7078 3.72766 15.8196 2.99702 18.0006 3.00001C19.1384 3.00007 20.2328 3.19487 21.2502 3.55499C21.5498 3.66101 21.75 3.94427 21.75 4.26201V18.512C21.75 18.7554 21.6319 18.9837 21.4332 19.1242C21.2345 19.2648 20.98 19.3003 20.7505 19.2193C19.8673 18.9077 18.9374 18.749 18.0008 18.75L17.999 18.75C15.9698 18.7472 14.0113 19.4953 12.5008 20.8503C12.2161 21.1057 11.7848 21.1059 11.4998 20.8508C10.0399 19.5441 8.11333 18.75 6 18.75C5.06344 18.749 4.13274 18.9077 3.24953 19.2193C3.02001 19.3003 2.76547 19.2648 2.56679 19.1242C2.36811 18.9837 2.25 18.7554 2.25 18.512V4.26201C2.25 3.94427 2.45022 3.66101 2.74975 3.55499C3.76721 3.19487 4.86161 3.00007 5.99948 3.00001C8.18039 2.99711 10.2922 3.72774 12 5.06396Z"
        fill={colorValue}
      />
    </svg>
  );
};
